<template>
  <div class="container">
    <div class="frame">
      <div class="frame__inner">
        <div class="frame__body">
          <div class="status">
            <div class="status__inner">
              <!-- v-if="data.status === 'success'" -->
              <div
                v-if="data.status === 'success'"
                class="status__item status-success"
              >
                <div class="status__icon">
                  <status-icon
                    :name="'success'"
                    :type="currentMerchant"
                  />
                </div>
                <div class="status__title">
                  {{ statusDefaultTitle[data.status] || 'Успешный перевод' }}
                </div>
                <div class="status__description">
                  {{ data.failure_description || statusDefaultDescription[data.status] || 'Платеж проведен' }}
                </div>
                <div class="status__receipt">
                  <a
                    v-if="data.receipt_url"
                    class="receipt"
                    :href="data.receipt_url"
                    target="_blank"
                  >
                    <div class="receipt__text">
                      {{ $t('get_check') }}
                    </div>
                    <img
                      class="receipt__icon "
                      src="@/assets/icons/receipt.svg"
                      alt="receipt__icon"
                    >
                  </a>
                </div>
                <div class="status__btn">
                  <ap-button
                    type="primary"
                    @click="toMain"
                  >
                    {{ $t('to_main') }}
                  </ap-button>
                </div>
              </div>

              <div
                v-else-if="data.status === 'error'" 
                class="status__item status-error"
              >
                <div class="status__icon">
                  <status-icon
                    :name="'error'"  
                    :type="currentMerchant"
                  />
                </div>
                <div class="status__title">
                  {{ statusDefaultTitle[data.status] }}
                </div>
                <div class="status__description">
                  {{ data.failure_description || statusDefaultDescription[data.status] }}
                </div>
                <div class="status__btn">
                  <ap-button
                    type="primary"
                    @click="toMain"
                  >
                    {{ $t('try_again') }}
                  </ap-button>
                </div>
              </div>

              <div
                v-else
                class="status__item status-process"
              >
                <div class="status__icon">
                  <div class="process">
                    <status-icon
                      :name="'process'"
                      class="process__icon"
                    />
                  </div>
                </div>
                <div class="status__title">
                  {{ statusDefaultTitle[data.status] || statusDefaultTitle['process'] }}
                </div>
                <div class="status__description">
                  {{ data.failure_description || statusDefaultDescription[data.status] || statusDefaultDescription['process'] }} 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

import { 
  IMBALANCE_CODE, 
  IMSUFFICIENT_FUNDS_CODE, 
  REMITTAMCES_TO_SIM 
} from '@/constant';

import apButton from '@/components/UI/apButton.vue';
import StatusIcon from '@/components/icons/statusIcon.vue';

export default defineComponent({
  components: {
    StatusIcon,
    apButton
  },
  props: {
    data: {
      type: Object,
      default: () => { 
        return {
          status: 'process'
        };
      }
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const router = useRouter();
    const store = useStore();
    const { t } = useI18n();
    
    const statusDefaultTitle = ref({
      process: t('status.process'),
      success: t('status.success'),
      error: t('status.error')
    });

    const statusDefaultDescription = ref({
      process: t('status.processDesc'),
      success: t('status.success'),
      error: t('status.errorDesc'),
      successNotReceipt: t('status.noReceipt')
    });

    const currentMerchant = computed(() => store.getters['merchant']);
    
    const toMain = () => {
      if (props.data.code 
          && (props.data.code === IMSUFFICIENT_FUNDS_CODE || props.data.code === IMBALANCE_CODE) 
          && props.data.paymentType === REMITTAMCES_TO_SIM
      ) {
        router.push({ name: 'sim-remittances' });
        return; 
      }
      store.commit('services/setServiceStatus', {});
      store.commit('simRemittances/setStatusOfRemittancesToSim', {});
      router.push({ name: 'main' });
      return;
    };

    return {
      toMain,
      statusDefaultTitle,
      statusDefaultDescription,
      currentMerchant,
      t
    };
  },
});
</script>
<style lang="scss" scoped>
.status{
  height: 622px;
  &__inner{
    padding: 80px 0 54px 0;
  }
  &__icon{
    margin-bottom: 30px;
  }
  &__item{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &__receipt{
    margin-bottom: 90px;
  }
  &__title{
    color: $primary-blue;
    font-weight: 600;
    font-size: 32px;
    line-height: 24px;
    text-align: center;
    margin-bottom: 16px;
  }
  &__description{
    text-align: center;
    color: $primary-gray;
    width: 80%;
    margin-bottom: 46px;
  }
}
.receipt{
  display: flex;
  &__text{
    color: $primary-purple;
    margin-right: 9px;
  }
}
.process{
  -webkit-animation:spin 1.5s linear infinite;
  -moz-animation:spin 1.5s linear infinite;
  animation:spin 1.5s linear infinite;
}
.process__icon{
  display: block;
  svg{
    display: block;
  }
}
@-moz-keyframes spin {
  100% { -moz-transform: rotate(360deg); }
}

@-webkit-keyframes spin {
100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform:rotate(360deg);
  }
}
@media (min-width: 320px) and (max-width: 375px) {
  .status{
    padding: 16px;
    &__title{
      font-size: 22px;
    }
     &__description{
       width: 100%;
     }
  }
}
.altel{
  .receipt{
    &__text{
      color: $primary-pink;
    }
    &__icon{
      filter: invert(13%) sepia(91%) saturate(6674%) hue-rotate(320deg) brightness(89%) contrast(104%);
    }
  }

  .status{
    &__title{
      color: $altel-primary-black;
    }
    &__description{
      color: $altel-primary-gray;
    }
  }
}
.tele2{
  .receipt{
    &__text{
      color: black;
    }
    &__icon{
      filter: invert(0%) sepia(1%) saturate(15%) hue-rotate(152deg) brightness(104%) contrast(100%);
    }
  }
    .status{
      &__title{
        color: $tele2-primary-black;
      }
      &__description{
        color: $tele2-primary-gray;
      }
    }
}
</style>